import { Link } from "react-router-dom";
import { Phone, Instagram } from "lucide-react";
import { Logo } from "@/components/Logo";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505]">
    <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
      <div>
        <Logo />
        <p className="text-sm text-zinc-500 mt-6 leading-relaxed max-w-xs">
          Power yourself like a label. Talent, fleet, production and results — booked by Benj, Los Angeles.
        </p>
      </div>
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">Services</p>
        <nav className="flex flex-col gap-3">
          <Link data-testid="footer-link-models" to="/models" className="text-sm text-zinc-300 hover:text-brand transition-colors">Models</Link>
          <Link data-testid="footer-link-cars" to="/cars" className="text-sm text-zinc-300 hover:text-brand transition-colors">Cars</Link>
          <Link data-testid="footer-link-houses" to="/houses" className="text-sm text-zinc-300 hover:text-brand transition-colors">Houses</Link>
          <Link data-testid="footer-link-marketing" to="/marketing" className="text-sm text-zinc-300 hover:text-brand transition-colors">Music Marketing</Link>
        </nav>
      </div>
      <div>
        <p className="text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">Contact</p>
        <a data-testid="footer-phone" href="tel:3234947199"
          className="flex items-center gap-2 text-zinc-300 hover:text-brand transition-colors text-sm">
          <Phone className="w-4 h-4 text-brand" /> 323-494-7199
        </a>
        <a data-testid="footer-instagram" href="https://www.instagram.com/bookedbybenj" target="_blank" rel="noreferrer"
          className="flex items-center gap-2 text-zinc-300 hover:text-brand transition-colors text-sm mt-3">
          <Instagram className="w-4 h-4 text-brand" /> Follow Us On Instagram
        </a>
        <p className="text-sm text-zinc-500 mt-3">Los Angeles, CA</p>
        <Link data-testid="footer-team-login" to="/login" className="inline-block mt-6 text-xs text-zinc-600 hover:text-zinc-300 transition-colors">
          Team Login
        </Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-zinc-600">
      © {new Date().getFullYear()} Booked By Benj. All rights reserved.
    </div>
  </footer>
);
